<script lang="ts" setup>
import { computed } from 'vue';

import useGetLookupCustomerCode from '@/composables/useGetLookupCustomerCode';

const props = withDefaults(
  defineProps<{
    modelValue?: string | null;
  }>(),
  {
    modelValue: null,
  },
);
const emit = defineEmits(['update:modelValue']);

const fieldValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

const { loading, customerCodes, getCustomerCodeList } =
  useGetLookupCustomerCode();

const search = async (customerCode: string): Promise<void> => {
  await getCustomerCodeList(customerCode);
};
</script>

<template>
  <v-autocomplete
    v-model="fieldValue"
    :items="customerCodes"
    :loading="loading"
    label="Customer code"
    :tabindex="1"
    variant="outlined"
    clearable
    :class="[$style.lookupOutlined]"
    data-testid="customerCodeLookup"
    @update:search="search"
  >
    <template #no-data>
      <v-list-item>
        <v-list-item-title v-if="loading">Loading...</v-list-item-title>
        <v-list-item-title
          v-else-if="
            !loading &&
            fieldValue &&
            fieldValue.length >= 1 &&
            customerCodes?.length === 0
          "
          >Not found</v-list-item-title
        >
        <v-list-item-title v-else
          >Enter more than 1 character</v-list-item-title
        >
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<style lang="scss" module src="@/styles/lookupOutlined.module.scss"></style>
